module.exports = __webpack_public_path__ + "static/img/step_03.0be0310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/binding/img/step_03.jpg
// module id = AMYP
// module chunks = 64